import { JSXElementConstructor } from 'react'
import produce from 'immer'
import { Reducer } from 'redux'
import { getPageUrl } from 'libraries/front-end-core/core/history'
import {
  HIDE_LAYOUT_NAVIGATION,
  LAYOUT_TOGGLE_FULL_SCREEN_OVERLAY,
  SET_LAYOUT_PAGE_ID,
  SHOW_LAYOUT_NAVIGATION,
  LAYOUT_WRAPPER_SET_URL,
  SET_LAYOUT_FLAVOUR,
  LAYOUT_WRAPPER_SET_BOTTLE_LINK,
  SET_LAYOUT_CONTROLLER,
  SET_LAYOUT_BROWSER,
  SET_LAYOUT_IS_TOUCH_DEVICE,
  SET_LAYOUT_HEADER_HEIGHT,
  SET_WINDOW_HEIGHT,
  SET_WINDOW_WIDTH,
  SET_DEVICE_TYPE,
  LAYOUT_WRAPPER_SET_PAGE_DATA,
  SET_BROWSER_IS_IE,
  SET_BROWSER_IS_IOS
} from 'redux/actions/types'
import { DEFAULT_FLAVOUR } from 'constants/flavours'
import { Flavour } from 'types/Flavour'
import { LayoutPageData, LayoutBrowser, LayoutDeviceType } from 'interfaces/layout'

export interface LayoutState {
  isNavigationVisible: boolean
  fullscreenOverlay: JSXElementConstructor<any> | null
  pageId: string | null
  controller: string | null
  url: string
  flavour: Flavour
  bottleLink: (flavour: string) => string
  pageData: LayoutPageData
  headerHeight: number
  windowHeight: number
  windowWidth: number
  browser: LayoutBrowser
  deviceType: LayoutDeviceType
  isTouchDevice: boolean
}

const initialState: LayoutState = {
  isNavigationVisible: false,
  fullscreenOverlay: null,
  pageId: null,
  controller: null,
  url: getPageUrl(location.href),
  flavour: DEFAULT_FLAVOUR,
  bottleLink: () => 'javascript:;',
  pageData: { fromDate: null, toDate: null },
  headerHeight: 0,
  windowHeight: 0,
  windowWidth: 0,
  browser: {
    name: '',
    isIE: false,
    isIOS: false
  },
  deviceType: {
    isTablet: false,
    isMobile: false,
    isDesktop: false,
    isDesktopFullscreen: false,
    isFullscreen: false,
    isLargeDesktop: false
  },
  isTouchDevice: false
}

const layout: Reducer<LayoutState, any> = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_LAYOUT_NAVIGATION:
      return produce(state, draft => {
        draft.isNavigationVisible = true
      })
    case HIDE_LAYOUT_NAVIGATION:
      return produce(state, draft => {
        draft.isNavigationVisible = false
      })
    case SET_LAYOUT_PAGE_ID:
      return produce(state, draft => {
        draft.pageId = action.pageId
      })
    case LAYOUT_TOGGLE_FULL_SCREEN_OVERLAY:
      return produce(state, draft => {
        draft.fullscreenOverlay = action.fullscreenOverlay
      })
    case LAYOUT_WRAPPER_SET_URL:
      return produce(state, draft => {
        draft.url = action.url
      })
    case SET_LAYOUT_FLAVOUR:
      return produce(state, draft => {
        draft.flavour = action.flavour
      })
    case LAYOUT_WRAPPER_SET_BOTTLE_LINK:
      return produce(state, draft => {
        draft.bottleLink = action.bottleLink
      })
    case LAYOUT_WRAPPER_SET_PAGE_DATA:
      return produce(state, draft => {
        draft.pageData = action.pageData
      })
    case SET_LAYOUT_CONTROLLER:
      return produce(state, draft => {
        draft.controller = action.controller
      })
    case SET_LAYOUT_BROWSER:
      return produce(state, draft => {
        draft.browser = action.browser
      })
    case SET_BROWSER_IS_IE:
      return produce(state, draft => {
        draft.browser.isIE = action.isIE
      })
    case SET_BROWSER_IS_IOS:
      return produce(state, draft => {
        draft.browser.isIOS = action.isIOS
      })
    case SET_LAYOUT_IS_TOUCH_DEVICE:
      return produce(state, draft => {
        draft.isTouchDevice = action.isTouchDevice
      })
    case SET_LAYOUT_HEADER_HEIGHT:
      return produce(state, draft => {
        draft.headerHeight = action.headerHeight
      })
    case SET_WINDOW_HEIGHT:
      return produce(state, draft => {
        draft.windowHeight = action.windowHeight
      })
    case SET_WINDOW_WIDTH:
      return produce(state, draft => {
        draft.windowWidth = action.windowWidth
      })
    case SET_DEVICE_TYPE:
      return produce(state, draft => {
        draft.deviceType = action.deviceType
      })
    default:
      return state
  }
}

export default layout
